import Marquee from "react-fast-marquee";
import { Clock, ArrowUpRight } from "lucide-react";

const ITEMS = [
  "Creative Thinking",
  "Around The Clock",
  "Brand Mitra 24",
  "SEO to AI Video",
  "Always On. Always Bold.",
];

export const EditorialMarquee = ({ dark = true }) => (
  <div
    data-testid="editorial-marquee"
    className={`${dark ? "bg-bm-navy text-white" : "bg-bm-blue text-white"} py-6 overflow-hidden`}
  >
    <Marquee speed={35} gradient={false} pauseOnHover>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-syne text-2xl sm:text-3xl font-bold uppercase tracking-tight px-8">
            {item}
          </span>
          {i % 2 === 0 ? (
            <Clock className="h-5 w-5 text-bm-blue" strokeWidth={2.5} />
          ) : (
            <ArrowUpRight className="h-5 w-5 text-bm-blue" strokeWidth={2.5} />
          )}
        </span>
      ))}
    </Marquee>
  </div>
);
